import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './Layout';
import {
  ProtectedRoute,
  PublicRoute,
  FinancialsRoute,
  HomeRedirect,
} from './AuthRoutes';
import { RouteErrorBoundary } from './ErrorBoundary';
import { LoginPage } from '@/features/auth/LoginPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { LazyWrapper, lazyPages } from './LazyWrapper';

const { PeriodsPage, DeductionsPage, ClassificationsPage, AnalysisGroupsPage, AnalyticsPage, AuditPage, CostCentersPage, BalancePage, ClassifiedExpensePage, ConfigEstadoResultadoPage, YearlyComparisonPage, CostosSubaplicadosPage, MayorCuentasPage, IntercompanyCuentasPage } = lazyPages;

export const router = createBrowserRouter([
  {
    element: <PublicRoute />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '/login',
        element: <LoginPage />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '/',
        element: <AppLayout />,
        errorElement: <RouteErrorBoundary />,
        children: [
          { index: true, element: <HomeRedirect /> },
          { path: 'comparativo-mensual', element: <FinancialsRoute><DashboardPage /></FinancialsRoute> },
          { path: 'comparativo-anual', element: <FinancialsRoute><LazyWrapper><YearlyComparisonPage /></LazyWrapper></FinancialsRoute> },
          { path: 'periodos', element: <LazyWrapper><PeriodsPage /></LazyWrapper> },
          { path: 'deducciones', element: <LazyWrapper><DeductionsPage /></LazyWrapper> },
          { path: 'clasificaciones', element: <LazyWrapper><ClassificationsPage /></LazyWrapper> },
          { path: 'agrupaciones-analisis', element: <LazyWrapper><AnalysisGroupsPage /></LazyWrapper> },
          { path: 'analisis', element: <FinancialsRoute><LazyWrapper><AnalyticsPage /></LazyWrapper></FinancialsRoute> },
          { path: 'auditoria', element: <LazyWrapper><AuditPage /></LazyWrapper> },
          { path: 'centros-costo', element: <LazyWrapper><CostCentersPage /></LazyWrapper> },
          { path: 'gasto-clasificado', element: <LazyWrapper><ClassifiedExpensePage /></LazyWrapper> },
          { path: 'balance-general', element: <FinancialsRoute><LazyWrapper><BalancePage /></LazyWrapper></FinancialsRoute> },
          { path: 'config-estado-resultado', element: <LazyWrapper><ConfigEstadoResultadoPage /></LazyWrapper> },
          { path: 'costos-subaplicados', element: <LazyWrapper><CostosSubaplicadosPage /></LazyWrapper> },
          { path: 'mayor-cuentas', element: <LazyWrapper><MayorCuentasPage /></LazyWrapper> },
          { path: 'intercompany-cuentas', element: <LazyWrapper><IntercompanyCuentasPage /></LazyWrapper> },
        ],
      },
    ],
  },
]);
